import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { Observable } from 'rxjs/Rx';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService } from 'ng-jhipster';

import { Feed } from './feed.model';
import { FeedPopupService } from './feed-popup.service';
import { FeedService } from './feed.service';

@Component({
    selector: 'dcs-feed-dialog',
    templateUrl: './feed-dialog.component.html'
})
export class FeedDialogComponent implements OnInit {

    feed: Feed;
    authorities: any[];
    isSaving: boolean;

    constructor(
        public activeModal: NgbActiveModal,
        private alertService: AlertService,
        private feedService: FeedService,
        private eventManager: EventManager
    ) {
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.feed.id !== undefined) {
            this.subscribeToSaveResponse(
                this.feedService.update(this.feed));
        } else {
            this.subscribeToSaveResponse(
                this.feedService.create(this.feed));
        }
    }

    private subscribeToSaveResponse(result: Observable<Feed>) {
        result.subscribe((res: Feed) =>
            this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
    }

    private onSaveSuccess(result: Feed) {
        this.eventManager.broadcast({ name: 'feedListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}

@Component({
    selector: 'dcs-feed-popup',
    template: ''
})
export class FeedPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private feedPopupService: FeedPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.feedPopupService
                    .open(FeedDialogComponent, params['id']);
            } else {
                this.modalRef = this.feedPopupService
                    .open(FeedDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/feed/feed-dialog.component.ts